import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
//logo-image
import logoImage from 'src/asset/images/logo/logo-basic_c_2.png';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/component/menu.module.scss'
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//Hook
import useAuthHook from 'src/webapp/hooks/auth/auth.hook';
//comp-wrapper
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default React.memo(function Menu(props) {
    const { isState, info } = usePartnerStore();//회원정보
    const location = useLocation();//locate
    const { onLogoutHandler } = useAuthHook();//로그아웃핸들러

    /* =============== 메뉴리스트 =============== */
    const nav = [
        { label: '대시보드', icon:'chart-simple', nav:`/dashboard` },
        { label: '알림', icon:'bell', nav:`/notify` },
        { label: '매출 관리', icon:'chart-area', nav:`/sales` },
        { label: '스케줄 관리', icon:'calendar-days', nav:`/schedule` },
        { label: '가격표 관리', icon:'calculator', nav:`/item` }, 
        { label: '회원 관리', icon:'users', nav:`/members` },
        { label: '정산관리', icon:'coins', nav:`/calc` },
        // { label: '라이더 마켓', icon:'store', nav:`/market` },
        { label: '마이페이지', icon:'user', nav:`/mypage` }
    ];
    /* =============== 메뉴리스트 =============== */
    /* =============== 현재페이지 포커스 =============== */
    useEffect(() => {
        if(document.getElementById('scrollTarget') === null) { return; }
        
        document.getElementById('scrollTarget').scrollIntoView({ behavior: 'smooth' });
    }, []);
    /* =============== 현재페이지 포커스 =============== */
    /* =============== 메타태그 - title =============== */
	useEffect(() => {
        if(!isState) { return; }
        
		const htmlTitle = document.querySelector("title");
    	htmlTitle.innerHTML = ((info.PARTNER_NAME ?? '두바키 파트너') + '님, 안녕하세요 | 두바키 파트너스');
	}, [isState]);
	/* =============== 메타태그 - title =============== */

    /* =============== 현재위치에 따른 메뉴포커스 =============== */
    const locateHandler = (nav) => {
        const locate = location.pathname;
        if((locate === '/' || locate === '/dashboard') && nav === '/dashboard') { return true; }
        if((locate.indexOf('market') > 0) && nav === '/market') { return true; }
        else if(locate === nav) { return true; }

        return false;
    }
    /* =============== 현재위치에 따른 메뉴포커스 =============== */

    return (
        <div className={styles.menuContainer}>
            <div>
                <FixedPanel>
                    <header>
                        <div className={styles.imgArea}><img src={logoImage} alt={`두바키 로고`} /></div>
                        <label>{info.PARTNER_NAME ?? '두바키 파트너'}님, 안녕하세요</label>
                        <button onClick={(e) => onLogoutHandler()}><span>로그아웃</span><FontAwesomeIcon icon={['fal', 'arrow-right-from-bracket']} /></button>
                    </header>
                </FixedPanel>
                <FlickPanel>
                    <nav>
                        <ul>
                            {nav.map((item, idx) => 
                                <li key={idx} 
                                    id={locateHandler(item.nav) ? "scrollTarget" : null}
                                    className={locateHandler(item.nav)  ? styles.selected : null} >
                                    <Link to={item.nav}>
                                        <FontAwesomeIcon icon={['fal', `${item.icon}`]} />
                                        <span>{item.label}</span>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </nav>
                </FlickPanel>
                <FixedPanel>
                    <footer>
                        <Link to={`/mypage`}>
                            <div className={styles.imgArea}>
                                <img src={`${process.env.REACT_APP_IMAGE_URL + info.IMG_SRC}`} alt={info.PARTNER_NAME} />
                            </div>
                            <div className={styles.infoArea}>
                                <label>+{info.DIFF ?? 0}일째 구독중</label>
                                <span>{info.LICENSE_DT ?? '0000-00-00'} 만료</span>
                            </div>
                            <small><FontAwesomeIcon icon={['fal', 'chevron-right']} /></small>
                        </Link>
                    </footer>
                </FixedPanel>
            </div>
        </div>
    );
});